import { useMemo } from 'react';
import { css, SerializedStyles } from '@emotion/react';
import { classNames } from '@frontend/string';
import { theme } from '@frontend/theme';
import { SearchField, useFormField } from '@frontend/design-system';
import type { LocationServiceLocationItem, LocationServiceRecentLocation } from '../../types/location.types';
import { SelectLocationCard, SelectLocationCardProps } from './select-location-card';

const styles = {
  root: css({
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  }),
  grid: css({
    display: 'grid',
    gap: theme.spacing(2),
  }),
};

export type LocationHistoryRenderItem = (props: SelectLocationCardProps) => React.ReactNode;

export type LocationSearchGridProps = {
  className?: string;
  locations: LocationServiceRecentLocation[];
  gridStyles?: SerializedStyles;

  ItemComponent?: LocationHistoryRenderItem;

  onRemoveLocation: (locationId: string) => void;
  onChangeLocation: (location: LocationServiceLocationItem) => void;
};
export const LocationSearchGrid = ({
  className,
  locations,
  gridStyles,
  ItemComponent = SelectLocationCard,
  onRemoveLocation,
  onChangeLocation,
}: LocationSearchGridProps) => {
  const searchField = useFormField({ type: 'text' });

  const filteredFields = useMemo(() => {
    return locations.filter((location) => {
      return location.name?.toLowerCase()?.includes(searchField.value.toLowerCase());
    });
  }, [searchField.value, locations]);
  return (
    <div className={classNames('search-grid', className)} css={styles.root}>
      <div className='search-grid__input'>
        <SearchField placeholder='Search by location name' name='search' {...searchField} />
      </div>
      <div className='search-grid__grid' css={[styles.grid, gridStyles]}>
        {filteredFields.map((location) => (
          <ItemComponent
            key={location?.locationId}
            location={location}
            onRemoveLocation={onRemoveLocation}
            onChangeLocation={onChangeLocation}
          />
        ))}
      </div>
    </div>
  );
};
